'use client';

import { ReactNode } from 'react';
import { AuthProvider } from './AuthContext';

/**
 * Auth provider for public pages
 * Skips fetching user data and server verification
 */
export function PublicAuthProvider({ children }: { children: ReactNode }) {
  return (
    <AuthProvider authOptions={{ skipFetch: true, skipServerVerification: true }}>
      {children}
    </AuthProvider>
  );
}

/**
 * Auth provider for standard auth pages
 * Uses lightweight fetch to reduce DB load
 */
export function StandardAuthProvider({ children }: { children: ReactNode }) {
  return (
    <AuthProvider authOptions={{ lightweightFetch: true }}>
      {children}
    </AuthProvider>
  );
}

/**
 * Auth provider for sensitive pages
 * Uses full verification and DB fetch
 */
export function SecureAuthProvider({ children }: { children: ReactNode }) {
  return (
    <AuthProvider authOptions={{ skipServerVerification: false, lightweightFetch: false }}>
      {children}
    </AuthProvider>
  );
} 